import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { EntitlementDeniedState, LoadingState } from "@odingard/design-system";
import { useAuth } from "../lib/auth";
import { useAsync } from "../lib/useAsync";
import { api } from "../lib/api";

export function SopGuard({ children }: { children: ReactNode }) {
  const { activeOrg } = useAuth();
  const navigate = useNavigate();
  const orgId = activeOrg?.id ?? "";
  const state = useAsync(async () => (orgId ? (await api.entitlements(orgId)).entitlements : []), [orgId]);
  if (state.loading) return <LoadingState label="Checking your SOP AI access…" />;
  const entitled = state.data?.some((item) => item.key === "sop_ai.enabled" && ["ALLOWED", "TRIAL"].includes(item.status)) ?? false;
  if (!entitled) return <EntitlementDeniedState product="SOP AI" onUpgrade={() => navigate("/pricing")} />;
  return <>{children}</>;
}

export function hasSopEntitlement(entitlements: readonly { key: string; status: string }[] | null | undefined): boolean {
  return entitlements?.some((item) => item.key === "sop_ai.enabled" && ["ALLOWED", "TRIAL"].includes(item.status)) ?? false;
}
